import { Directive, ElementRef, NgZone } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { PopoverBaseDirective } from 'Angular/features/directives/popovers/base/popover-base.directive';

/**
 * Popover Directive
 *
 * Extends the base popover directive and sets the event listeners to be on click for showing and on blur for hiding
 *
 */
@Directive({
    selector: '[ycnPopover]',
    standalone: false,
})
export class PopoverDirective extends PopoverBaseDirective {
    constructor(protected el: ElementRef, sanitizer: DomSanitizer, private ngZone: NgZone) {
        super(el, sanitizer);
        this.ngZone.runOutsideAngular(() => {
            this.el.nativeElement.addEventListener('click', () => {
                this.toggleTooltip();
            });
            this.el.nativeElement.addEventListener('mouseenter', () => {
                this.hideTooltip();
            });
        });
    }

    isTooltip(): boolean {
        return false;
    }
}
